import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import CategorySection from "./components/CategorySection";
import FeaturedEvents from "./components/FeaturedEvents";
import UpdateTimeline from "./components/UpdateTimeline";
import GlossarySection from "./components/GlossarySection";
import VoiceSection from "./components/VoiceSection";
import FaqSection from "./components/FaqSection";
import SubscribeCta from "./components/SubscribeCta";
import { events } from "@/mocks/events";
import { faqs } from "@/mocks/faq";

const SITE = "https://9jzs.cn";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "瓜田观察站",
      url: SITE,
      description:
        "整理网络热点事件的公开脉络，按分类归档、以时间线呈现，帮助读者理性围观、看清事件来龙去脉。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE}/topics?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "瓜田观察站",
      url: SITE,
      email: "contact@guatian-observer.example.com",
      description: "只整理公开信息的热点事件档案站，坚持不呈现个人隐私、不传播未经证实的内容。",
      knowsAbout: ["网络热点整理", "事件时间线", "内容观察", "舆情脉络"],
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "精选事件档案",
      itemListElement: events.slice(0, 6).map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${SITE}/topic/${item.id}`,
        name: item.title,
      })),
    },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="瓜田观察站 · 网络热点事件档案与时间线整理"
        description="瓜田观察站整理网络热点事件的公开脉络，按直播圈、短视频、电商带货等分类归档，用时间线讲清来龙去脉，配吃瓜百科与网友讨论，让你围观不迷路。"
        keywords="网络热点,事件档案,时间线整理,吃瓜百科,娱乐观察,话题讨论"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HotBoard />
        <CategorySection />
        <FeaturedEvents />
        <UpdateTimeline />
        <GlossarySection />
        <VoiceSection />
        <FaqSection />
        <SubscribeCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}